import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectInfo } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { selectStagedTransactionForm } from '../../../../../create-request/reducers';
import { transactionTypes } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { isAchForm } from '../../../../../create-request/models/form/TransactionForm';

@Component({
  standalone: false,
  selector: 'mm-transaction-review-ach',
  templateUrl: './transaction-review-ach.component.html',
  styleUrl: './transaction-review-ach.component.scss'
})
export class TransactionReviewAchComponent implements OnInit{

  readonly sourceSubtitle: string = 'Source account details';
  readonly receivingSubtitle: string = 'Receiving account details';

  readonly ach: string = transactionTypes.ach;
  isIra: boolean;
  isPtrs: boolean;
  destroy$: Subject<void> = new Subject<void>();
  transferDirection: string;

  constructor(private store: Store){    
  }

  ngOnInit(): void {
    combineLatest([
      this.store.pipe(select(selectStagedTransactionForm)),
      this.store.pipe(select(selectInfo))
    ]).pipe(takeUntil(this.destroy$))
    .subscribe(([form, info]) => {
      if (form?.transactionType && isAchForm(form)) {
        const extraPrompts = form.extraPrompts;
        this.transferDirection = extraPrompts.transferDirection;
      }
      this.isIra = info.classifications.isIra;
      this.isPtrs = info.classifications.isPtrs;
    });
  }

  get isIncoming(): boolean {
    return this.transferDirection === 'incoming';
  }
}
